import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { HyperDxService } from 'src/app/services/hyperdx.service';
import { IntercomService } from 'src/app/services/intercom.service';

@Component({
  selector: 'app-private-header',
  templateUrl: './private-header.component.html',
  styleUrls: ['./private-header.component.sass']
})
export class PrivateHeaderComponent implements OnInit, OnChanges {
  username = ""
  userOptions = false;

  constructor(
    private router: Router, 
    private authService: AuthService,
    private hyperDxService: HyperDxService,
    private intercomService: IntercomService
  ) {
  }

  ngOnInit(): void {
    this.username = this.authService.getUsername()
      .split(' ').splice(0, 2).join(' ')
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  hoverUserOption() {
    this.userOptions = !this.userOptions
  }

  logout() {
    // Registra o evento de logout
    this.hyperDxService.logAction('user-logout', {
      userId: this.authService.getUserId(),
      userName: this.authService.getUsername(),
      userEmail: this.authService.getUserEmail()
    });
    
    // Limpa a identificação do usuário no HyperDX
    this.hyperDxService.clearUserIdentification();

    // Encerra o Intercom
    this.intercomService.shutdown();
    
    // Limpa os dados de autenticação
    this.authService.clear();
    
    // Redireciona para o novo site padrão
    window.location.href = '/home';
  }

  onClickLogo() {
    // Sempre redireciona para home quando clicar no logo
    this.router.navigate(['main', 'home']);
  }

}
